export type StatusEnum = 'ACTIVE' | 'INACTIVE';

export const StatusEnumValues = {
    Active: 'ACTIVE' as StatusEnum,
    Inactive: 'INACTIVE' as StatusEnum,
};
